<template>
    <div class="main">
        <my_menu></my_menu>

        <div class="content">
            <div>
                <Tabs v-model="tabs_index" @on-click='click_tabs'>
                    <TabPane v-for="(item, i) in tabs_options" :key="i" :label="item.label" :name="item.value">
                        <div class="add_button_div">
                            <span class="tishi_txt">
                                <Icon type="md-alert" size="16" color="#0466dd" /> 字段ID需要为简历库的ID，当前组id:
                                <span>{{ item.value }}</span>
                            </span>
                            <Button style="font-size:12px" type="primary" size="small" @click="add_show = true">
                                <Icon type="md-add" />添加新字段
                            </Button>
                        </div>
                    </TabPane>
                </Tabs>
            </div>


            <div class="table_box">
                <Spin fix size="large" v-if="table_loading"></Spin>
                <Table size="small" :height="windowHeight - 110" border :columns="columns" :data="table_data">
                    <template #action="{ row }">
                        <a class="editor_field" @click="click_editor(row)">编辑</a>
                    </template>
                </Table>
            </div>

        </div>

        <Modal v-model="add_show" title="添加字段" :footer-hide="true" width="500">
            <div>
                <div class="add_item">
                    <div class="add_item_field">字段类型:</div>
                    <Select v-model="add_field_data.field_type" style="width:300px">
                        <Option value="0">简历库字段</Option>
                        <Option value="1">项目附加字段</Option>
                    </Select>
                </div>
                <div class="add_item">
                    <div class="add_item_field">字段id:</div>
                    <Input v-model="add_field_data.field_id" placeholder="请输入字段id" style="width: 300px" />
                </div>
                <div class="add_item">
                    <div class="add_item_field">字段名称:</div>
                    <Input v-model="add_field_data.name" placeholder="请输入字段名称" style="width: 300px" />
                </div>
                <div class="add_button">
                    <Button type="primary" @click="add_field">确认添加</Button>

                </div>


            </div>
        </Modal>

        <Drawer title="编辑数据" :closable="true" v-model="update_show" width="400">
            <div>
                <div class="update_field_item">
                    <div class="update_field_width">
                        字段名称:
                    </div>
                    <Input v-model="update_item.name" @on-blur="update_blur(update_item.id,'name',update_item.name)" placeholder="输入内容.."
                        style="width: 300px" />
                </div>
                <div class="update_field_item">
                    <div class="update_field_width">
                        表格宽度:
                    </div>
                    <Input v-model="update_item.width" @on-blur="update_blur(update_item.id,'width',update_item.width)" placeholder="输入内容.."
                        style="width: 300px" />
                </div>
                <div class="update_field_item">
                    <div class="update_field_width">
                        字段顺序:
                    </div>
                    <Input v-model="update_item.weight" @on-blur="update_blur(update_item.id,'weight',update_item.weight)" placeholder="输入内容.."
                        style="width: 300px" />
                </div>
                <div class="update_field_item">
                    <div class="update_field_width">
                        表格type:
                    </div>
                    <Input v-model="update_item.type" @on-blur="update_blur(update_item.id,'type',update_item.type)" placeholder="输入内容.."
                        style="width: 300px" />
                </div>

            </div>
        </Drawer>
    </div>


</template>

<script>
import my_menu from '@/component/menu/menu.vue'
import { http } from "@/utils/http.js";

export default {
    components: {
        my_menu
    },
    data() {
        return {
            windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
            windowHeight: document.documentElement.clientHeight,   //实时屏幕高度

            //系统列表
            table_data: [],
            columns: [],
            table_loading: false,
            page: 1,
            add_field_show: false,

            tabs_options: [],
            tabs_index: '',

            add_show: false,
            add_field_data: {
                field_type: '0',
                field_id: "",
                name: "",
            },
            update_show: false,
            update_item: {}
        }
    },

    mounted() {
        this.window_change()
        this.get_tabs_options()
    },

    methods: {
        update_blur(id,key,value) {
            var that = this
            var obj = {
                id: id,
                key: key,
                value: value
            }
            http("post", process.env.VUE_APP_HOST + "/roster_manage/template/update_field", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.get_field_list()
                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });
                        that.update_show = false

                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                }
            ).catch((res) => {

                console.log(res, '请求出错')
            })
        },

        click_editor(item) {
            this.update_item = JSON.parse(JSON.stringify(item))
            this.update_show = true
        },

        click_tabs(e) {
            this.tabs_index = e
            this.get_field_list()
        },
        //确认添加
        add_field() {
            var that = this
            var obj = {
                field_type: this.add_field_data.field_type,
                field_id: this.add_field_data.field_id,
                name: this.add_field_data.name,
                group_id: this.tabs_index
            }
            http("post", process.env.VUE_APP_HOST + "/roster_manage/template/add_field", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.get_field_list()
                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });
                        that.add_show = false

                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                }
            ).catch((res) => {

                console.log(res, '请求出错')
            })
        },


        //获取标签数据
        get_tabs_options() {
            var that = this
            var obj = {
            }
            http("post", process.env.VUE_APP_HOST + "/roster_manage/template/tabs_options", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.tabs_options = res.data.options
                        that.tabs_index = res.data.options[0]['value']
                        that.get_field_list()
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                }
            ).catch((res) => {

                console.log(res, '请求出错')
            })
        },


        //获取字段列表
        get_field_list() {
            var that = this
            var obj = {

                group_id: this.tabs_index
            }
            this.table_loading = true
            http("post", process.env.VUE_APP_HOST + "/roster_manage/template/list", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.table_data = res.data.table_data
                        that.columns = res.data.columns

                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                    that.table_loading = false
                }
            ).catch((res) => {
                that.table_loading = false

                console.log(res, '请求出错')
            })
        },

        window_change() {
            var that = this;
            // <!--把window.onresize事件挂在到mounted函数上-->
            window.onresize = () => {
                return (() => {
                    window.fullHeight = document.documentElement.clientHeight;
                    window.fullWidth = document.documentElement.clientWidth;
                    that.windowHeight = window.fullHeight;  // 高
                    that.windowWidth = window.fullWidth; // 宽
                })()
            };
        }
    }
}
</script>

<style scoped>
.update_field_item {
    margin: 10px;
    display: flex;
    align-items: center;
}

.update_field_width {
    width: 100px;
    flex-shrink: 0;
}

.editor_field {
    color: #0466dd;
}

.add_item_field {
    width: 100px;
    flex-shrink: 0;
}

.add_item {
    margin: 10px;
    display: flex;
    align-items: center;
}

.add_button {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
}

.tishi_txt {
    font-size: 13px;
    color: #666;
    padding-left: 10px;
}

.add_button_div {
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
}

.content_page {
    display: flex;
    justify-content: center;
    padding-top: 10px;
}

/deep/ .ivu-tabs-bar {
    margin-bottom: 10px;
}

.circular {
    width: 25px;
    height: 25px;
}

.table_box {
    position: relative;
}

.add_sys_button {
    margin-top: 20px;
    text-align: right;
}

.form_item_title {
    flex-shrink: 0;
    width: 100px;
}

.form_item {
    display: flex;
    align-items: center;
}

.options {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
}
.content {
    width: calc(100% - 180px);
    background-color: #fff;
    position: absolute;
    right: 0px;
    top: 0px;
    height: 100vh;
    padding: 10px;
}

.main {
    background: #f5f7f9;
    min-height: 100vh;
}
</style>